export default function NotFoundPage() {
    return (
        <div>
            404 Not Found
        </div>
    )
}